import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { OsmVersion } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const osmVersionsUrl = `${environment.apiUrl}/osmversions`;
const currentOsmVersionUrl = `${osmVersionsUrl}/current`;
const latestOsmVersionUrl = `${osmVersionsUrl}/latest`;
const importedOsmVersionsUrl = `${osmVersionsUrl}/imported`;
const deleteOsmVersionUrl = osmVersionid => `${osmVersionsUrl}/${osmVersionid}/deleteSchema`;
const OsmVersionForIdUrl = (id: number) => `${osmVersionsUrl}/${id}`;
const approveOsmVersionUrl = (id: number) => `${OsmVersionForIdUrl(id)}/approve`;

@Injectable()
export class OsmVersionService {
  public currentOsmVersion: OsmVersion;

  constructor(private readonly httpService: HttpService) {}

  getOsmVersions(): Observable<OsmVersion[]> {
    return this.httpService.get<OsmVersion[]>(osmVersionsUrl);
  }

  getCurrentOsmVersion(): Observable<OsmVersion> {
    return this.httpService.get<OsmVersion>(currentOsmVersionUrl);
  }

  getLatestOsmVersion(): Observable<OsmVersion> {
    return this.httpService.get<OsmVersion>(latestOsmVersionUrl);
  }

  getImportedOsmVersions(): Observable<OsmVersion[]> {
    return this.httpService.get<OsmVersion[]>(importedOsmVersionsUrl);
  }

  deleteOsmVersion(osmVersionId: number): Observable<any> {
    return this.httpService.delete(deleteOsmVersionUrl(osmVersionId));
  }

  approveOsmVersion(id: number): Observable<void> {
    const url = approveOsmVersionUrl(id);
    return this.httpService.post(url, {});
  }
}



// WEBPACK FOOTER //
// ./src/app/services/osm-version.service.ts